/* =========================================================================
   Blackfire theme JS — carousel, quick-add, mobile drawer
   ========================================================================= */
(function () {
  'use strict';

  /* ----- Carousel -------------------------------------------------------- */
  function initCarousel(root) {
    var track = root.querySelector('[data-carousel-track]');
    var prev = root.querySelector('[data-carousel-prev]');
    var next = root.querySelector('[data-carousel-next]');
    if (!track) return;

    function cardStep() {
      var first = track.children[0];
      if (!first) return 200;
      var gap = parseInt(getComputedStyle(track).columnGap || getComputedStyle(track).gap || 12, 10);
      return first.offsetWidth + gap;
    }

    function updateButtons() {
      if (!prev || !next) return;
      prev.toggleAttribute('disabled', track.scrollLeft <= 4);
      next.toggleAttribute('disabled', track.scrollLeft + track.clientWidth >= track.scrollWidth - 4);
    }

    if (prev) {
      prev.addEventListener('click', function () {
        track.scrollBy({ left: -cardStep(), behavior: 'smooth' });
      });
    }
    if (next) {
      next.addEventListener('click', function () {
        track.scrollBy({ left: cardStep(), behavior: 'smooth' });
      });
    }

    track.addEventListener('scroll', updateButtons, { passive: true });
    window.addEventListener('resize', updateButtons);
    updateButtons();
  }

  document.querySelectorAll('[data-carousel]').forEach(initCarousel);

  /* ----- Quick add (Cart AJAX) ------------------------------------------ */
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    e.preventDefault();

    var variantId = btn.getAttribute('data-variant-id');
    if (!variantId) return;

    var originalText = btn.textContent;
    btn.textContent = 'Adding…';
    btn.disabled = true;

    fetch('/cart/add.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', 'Accept': 'application/json' },
      body: JSON.stringify({ items: [{ id: variantId, quantity: 1 }] })
    })
      .then(function (r) { return r.json(); })
      .then(function () { return fetch('/cart.js'); })
      .then(function (r) { return r.json(); })
      .then(function (cart) {
        btn.textContent = 'Added ✓';
        var counter = document.querySelector('[data-cart-count]');
        if (counter) counter.textContent = cart.item_count;
        setTimeout(function () {
          btn.textContent = originalText;
          btn.disabled = false;
        }, 1400);
      })
      .catch(function () {
        btn.textContent = 'Try again';
        btn.disabled = false;
      });
  });

  /* ----- Mobile drawer --------------------------------------------------- */
  var drawer = document.querySelector('[data-mobile-drawer]');
  // Both the hamburger AND the close button use [data-mobile-menu-toggle] —
  // delegate from the document so all toggles work.
  if (drawer) {
    document.addEventListener('click', function (e) {
      var toggle = e.target.closest('[data-mobile-menu-toggle]');
      if (!toggle) return;
      var isOpen = !drawer.hasAttribute('hidden');
      if (isOpen) {
        drawer.setAttribute('hidden', '');
        document.body.style.overflow = '';
      } else {
        drawer.removeAttribute('hidden');
        document.body.style.overflow = 'hidden';
      }
    });

    // In-drawer mega-menu accordion toggles
    drawer.querySelectorAll('[data-drawer-toggle]').forEach(function (btn) {
      btn.addEventListener('click', function () {
        var item = btn.closest('[data-drawer-item]');
        if (!item) return;
        var panel = item.querySelector('.bf-mobile-drawer__panel');
        var isOpen = item.hasAttribute('data-open');
        if (isOpen) {
          item.removeAttribute('data-open');
          btn.setAttribute('aria-expanded', 'false');
          if (panel) panel.setAttribute('hidden', '');
        } else {
          item.setAttribute('data-open', '');
          btn.setAttribute('aria-expanded', 'true');
          if (panel) panel.removeAttribute('hidden');
        }
      });
    });
  }

  /* ----- Announcement bar rotation -------------------------------------- */
  var bar = document.querySelector('[data-announcement-track]');
  if (bar && bar.children.length > 1) {
    var index = 0;
    setInterval(function () {
      index = (index + 1) % bar.children.length;
      bar.style.transform = 'translateX(' + (-index * 100) + '%)';
    }, 5000);
  }
})();

/* =========================================================================
   Cart drawer
   ========================================================================= */
(function () {
  'use strict';

  var drawer = document.querySelector('[data-drawer]');
  var overlay = document.querySelector('[data-drawer-overlay]');
  if (!drawer || !overlay) return;

  function openDrawer() {
    drawer.removeAttribute('hidden');
    overlay.removeAttribute('hidden');
    document.body.style.overflow = 'hidden';
  }
  function closeDrawer() {
    drawer.setAttribute('hidden', '');
    overlay.setAttribute('hidden', '');
    document.body.style.overflow = '';
  }

  document.addEventListener('click', function (e) {
    if (e.target.closest('[data-drawer-close]') || e.target === overlay) {
      closeDrawer();
    }
    if (e.target.closest('[data-cart-icon]')) {
      e.preventDefault();
      openDrawer();
    }
  });

  // Override default quick-add to also open drawer
  var originalQuickAdd = document.querySelector('[data-quick-add]');
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-quick-add]');
    if (!btn) return;
    // The existing quick-add handler runs first and adds to cart.
    // We open the drawer shortly after so the user sees the result.
    setTimeout(function () {
      refreshDrawer().then(openDrawer);
    }, 600);
  });

  // Refresh drawer contents from /cart.js
  function refreshDrawer() {
    return fetch('/?section_id=cart-drawer')
      .then(function (r) { return r.text(); })
      .then(function (html) {
        var temp = document.createElement('div');
        temp.innerHTML = html;
        var fresh = temp.querySelector('[data-drawer]');
        if (fresh) {
          drawer.innerHTML = fresh.innerHTML;
        }
      })
      .catch(function () {});
  }

  // Quantity update handler
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty-update]');
    if (!btn) return;
    e.preventDefault();
    var key = btn.getAttribute('data-key');
    var qty = parseInt(btn.getAttribute('data-quantity'), 10);
    if (qty < 0) qty = 0;

    fetch('/cart/change.js', {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ id: key, quantity: qty })
    })
      .then(function (r) { return r.json(); })
      .then(function () { refreshDrawer(); })
      .catch(function () {});
  });
})();

/* =========================================================================
   Collection page — heat filter + sort
   ========================================================================= */
(function () {
  'use strict';

  var filterPills = document.querySelectorAll('[data-heat-filter] [data-heat]');
  var sortSelect = document.querySelector('[data-sort]');
  var grid = document.querySelector('[data-product-grid]');
  if (!filterPills.length || !grid) return;

  filterPills.forEach(function (pill) {
    pill.addEventListener('click', function () {
      filterPills.forEach(function (p) { p.classList.remove('is-active'); });
      pill.classList.add('is-active');

      var heat = pill.getAttribute('data-heat');
      grid.querySelectorAll('[data-product-tile]').forEach(function (tile) {
        if (heat === 'all' || tile.getAttribute('data-heat-level') === heat) {
          tile.removeAttribute('data-hidden');
        } else {
          tile.setAttribute('data-hidden', '');
        }
      });
    });
  });

  if (sortSelect) {
    sortSelect.addEventListener('change', function () {
      var tiles = Array.prototype.slice.call(grid.querySelectorAll('[data-product-tile]'));
      var sortBy = sortSelect.value;

      tiles.sort(function (a, b) {
        if (sortBy === 'heat-asc') return parseInt(a.getAttribute('data-heat-level'), 10) - parseInt(b.getAttribute('data-heat-level'), 10);
        if (sortBy === 'heat-desc') return parseInt(b.getAttribute('data-heat-level'), 10) - parseInt(a.getAttribute('data-heat-level'), 10);
        return 0;
      });

      tiles.forEach(function (tile) { grid.appendChild(tile); });
    });
  }
})();

/* =========================================================================
   PDP — quantity stepper
   ========================================================================= */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-qty]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('[data-qty-input]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 1;
    if (btn.getAttribute('data-qty') === 'plus') current += 1;
    else if (current > 1) current -= 1;
    input.value = current;
  });
})();

/* =========================================================================
   Desktop mega menu — hover-with-delay so the dropdown doesn't snap shut
   if the cursor briefly leaves the trigger before reaching the panel.
   ========================================================================= */
(function () {
  'use strict';
  var HOVER_OPEN_DELAY = 80;   // small open delay to prevent flicker on quick fly-overs
  var HOVER_CLOSE_DELAY = 280; // generous close delay — feels natural without sticking around forever

  document.querySelectorAll('.bf-nav-list__item--has-mega').forEach(function (item) {
    var openTimer;
    var closeTimer;

    function open() {
      clearTimeout(closeTimer);
      openTimer = setTimeout(function () { item.classList.add('is-open'); }, HOVER_OPEN_DELAY);
    }

    function close() {
      clearTimeout(openTimer);
      closeTimer = setTimeout(function () { item.classList.remove('is-open'); }, HOVER_CLOSE_DELAY);
    }

    item.addEventListener('mouseenter', open);
    item.addEventListener('mouseleave', close);
    item.addEventListener('focusin', open);
    item.addEventListener('focusout', function (e) {
      // Only close if focus moves OUT of the item entirely
      if (!item.contains(e.relatedTarget)) close();
    });
  });
})();

/* =========================================================================
   Cart page — +/− quantity stepper (updates input; user clicks Update)
   ========================================================================= */
(function () {
  'use strict';
  document.addEventListener('click', function (e) {
    var btn = e.target.closest('[data-cart-qty]');
    if (!btn) return;
    e.preventDefault();
    var input = btn.parentElement.querySelector('[data-cart-qty-input]');
    if (!input) return;
    var current = parseInt(input.value, 10) || 0;
    if (btn.getAttribute('data-cart-qty') === 'plus') current += 1;
    else if (current > 0) current -= 1;
    input.value = current;
  });
})();
